import { render, staticRenderFns } from "./IngestTableV2.vue?vue&type=template&id=1c18dfea&scoped=true"
import script from "./IngestTableV2.vue?vue&type=script&lang=js"
export * from "./IngestTableV2.vue?vue&type=script&lang=js"
import style0 from "./IngestTableV2.vue?vue&type=style&index=0&id=1c18dfea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18dfea",
  null
  
)

export default component.exports